import { useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { request } from '!core/api';
import {
  i18nSlice,
  selectCulturesAvailable,
  selectCurrentLanguageId,
} from '!core/features';
import { resetStateAction } from '!core/redux';
import { authSlice, onboardingSlice } from '»components/Auth';
import {
  legalStatusListSelector,
  onboardingCreateAccountDisclaimerSelector,
} from '»components/Auth/Onboarding/redux/onboarding.selectors';
import { useHandleSagaError } from '»utils/customHooks';

import { disclaimersServices } from '../TrlDisclaimer';
import { TrlRadioOptions } from '../TrlRadioOptions';
import { languagesServices } from './chooseLanguage.services';

export const TrlChooseLanguage = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  const languages = useSelector(selectCulturesAvailable);
  const favouriteLanguageId = useSelector(selectCurrentLanguageId);
  const legalStatusList = useSelector(legalStatusListSelector);
  const acceptUsePersonalDataLabel = useSelector(
    onboardingCreateAccountDisclaimerSelector,
  );

  const { handleSagaError } = useHandleSagaError();

  const changeFavouriteLanguage = (event) => {
    languagesServices
      .changeLanguage({
        languageId: event.target.value,
      })
      .then(() => {
        /** Atualiza o redux com o novo idioma */
        const languageId = event.target.value;
        const { languageCode } = languages.find(
          (lang) => lang.languageId === languageId,
        );

        dispatch(
          i18nSlice.actions.setUserLanguage({
            languageId,
            languageCode,
          }),
        );

        dispatch(resetStateAction());

        /** Atualiza as propriedades enviadas no header dos endpoints */
        request.setCulture({
          languageId,
          languageCode,
        });

        /** Reload do Trader Lite com o novo idioma */
        dispatch(authSlice.actions.newUuid());

        if (acceptUsePersonalDataLabel !== undefined) {
          disclaimersServices
            .getDisclaimerNoAuth({ context: 'ONBOARDING_ACCEPT' })
            .then((disclaimerResponse) => {
              dispatch(
                onboardingSlice.actions.setCreateAccountDisclaimer({
                  disclaimer: disclaimerResponse[0].body,
                }),
              );
            });
        }

        if (legalStatusList.length !== 0)
          dispatch(onboardingSlice.actions.getLegalStatusListRequest());
      })
      .catch((error) => {
        handleSagaError(error);
      });
  };

  const refactoredLanguages = languages.reduce((acc, language) => {
    acc.push({
      id: language.languageId,
      label: language.descr,
    });

    return acc;
  }, []);

  return (
    <TrlRadioOptions
      title="TRLT_UI-CHOOSE_LANGUAGE"
      descr="TRLT_UI-LANGUAGE_WARNING"
      options={refactoredLanguages}
      selectedOptionId={favouriteLanguageId}
      handleChange={changeFavouriteLanguage}
      width={isDesktop && '457px'}
    />
  );
};
